import React from 'react';
import { LAST_UPDATED_COLUMN } from '../shared-constants';
import {
  prettyPhone,
  formatEIN,
  formatCurrencyOnBlur,
  required,
  phoneNumberVal,
  emailVal,
} from '../../helpers/utils';
import TableLink from '../../components/TableLink';

export const CLIENT_COLUMNS = [
  {
    Header: 'Client',
    accessor: 'name',
    Cell: ({ row: { original } }) => {
      return (
        <TableLink to={`/clients/edit/${original.id}`}>
          {original.fullName}
        </TableLink>
      );
    },
  },
  {
    Header: 'Address',
    accessor: 'address',
    Cell: ({ cell: { value } }) => (
      <span style={{ width: '160px', display: 'block' }}>{value}</span>
    ),
  },
  {
    Header: 'Web',
    accessor: 'website',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'POC',
    accessor: 'poc',
    Cell: ({ cell: { value } }) => {
      if (!value) return null;
      return <span style={{ width: '130px', display: 'block' }}>{value}</span>;
    },
  },
  {
    Header: 'Phone',
    type: 'phone',
    accessor: 'poc_phone',
    Cell: ({ cell: { value } }) => {
      if (!value) return null;
      return (
        <span style={{ width: '110px', display: 'block' }}>
          {prettyPhone(value)}
        </span>
      );
    },
  },
  {
    Header: 'Email',
    accessor: 'poc_email',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'EIN',
    accessor: 'tax_id',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'Focus',
    accessor: 'focus',
  },
  { ...LAST_UPDATED_COLUMN },
];

export const CLIENT_FIELDS = [
  { name: 'name', label: 'Client Name', validate: required },
  { name: 'address', label: 'Address', validate: required },
  { name: 'city', label: 'City', validate: required },
  {
    name: 'state',
    label: 'State',
    type: 'dropdown',
    component: 'select',
    validate: required,
  },
  {
    name: 'country',
    label: 'Country',
    type: 'dropdown',
    component: 'select',
    validate: required,
  },
  { name: 'zip', label: 'Zip', validate: required },
  { name: 'website', label: 'Website' },
  { name: 'tax_id', label: 'EIN' },
  { name: 'focus', label: 'Focus' },
];

export const CONTRACT_TYPES = [
  {
    label: 'Yearly',
    value: 'Yearly',
  },
  {
    label: 'Monthly',
    value: 'Monthly',
  },
  {
    label: 'Quarterly',
    value: 'Quarterly',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const EDIT_FIELDS = [
  {
    name: 'name',
    label: 'Client Name',
    validate: required,
  },
  {
    name: 'nickname',
    label: 'Nickname',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'dropdown',
    component: 'select',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
    ],
  },
  {
    name: 'ceo_name',
    label: 'Account Executive',
  },
  {
    name: 'contract_type',
    label: 'Contract Type',
    type: 'dropdown',
    component: 'select',
    options: CONTRACT_TYPES,
  },
  {
    name: 'address',
    label: 'Address',
    validate: required,
  },
  {
    name: 'city',
    label: 'City',
    validate: required,
  },
  {
    name: 'state',
    label: 'State',
    type: 'dropdown',
    component: 'select',
    validate: required,
  },
  {
    name: 'country',
    label: 'Country',
    type: 'dropdown',
    component: 'select',
    validate: required,
  },
  {
    name: 'zip',
    label: 'Zip',
    validate: required,
  },
  {
    name: 'website',
    label: 'Website',
  },
  {
    name: 'phone',
    label: 'Phone',
    type: 'phone',
    transformOnBlur: prettyPhone,
    validate: phoneNumberVal,
  },
  {
    name: 'email',
    label: 'Email',
    validate: emailVal,
  },
  {
    name: 'fax',
    label: 'Fax',
    type: 'phone',
    transformOnBlur: prettyPhone,
    validate: phoneNumberVal,
  },
  {
    name: 'founding_date',
    label: 'Founding Date',
    type: 'date',
  },

  {
    name: 'tax_id',
    label: 'Tax ID',
    transformOnBlur: formatEIN,
  },
  {
    name: 'focus',
    label: 'Focus',
  },
  {
    name: 'current_budget',
    label: 'Current Budget',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  {
    name: 'poc',
    label: 'Point of Contact',
  },
  {
    name: 'poc_title',
    label: 'POC title',
  },
  {
    name: 'poc_phone',
    label: 'POC Phone',
    type: 'phone',
    transformOnBlur: prettyPhone,
  },
  {
    name: 'poc_email',
    label: 'POC Email',
  },
  {
    name: 'notes',
    label: 'Notes',
    multiline: true,
  },
];
